import { useMutation, useQueryClient } from '@tanstack/react-query';
import request from '@teetsh/app/src/utils/request';
import { useSchoolSchoolyear } from '@teetsh/app/src/containers/App/context/SchoolyearSchoolProvider';
import { ELEVES_CUSTOM_FIELDS_KEY } from './useElevesCustomFields';
import {
  CustomFieldDefinition,
  CustomFieldOption,
} from '@teetsh/app/src/types/customField';
import { ELEVES_VIEWS_KEY } from 'queries/eleves/views/useElevesViews';
import { ELEVES_ACCOUNT_KEY } from '../useEleves';

function updateEleveCustomFields(props: {
  schoolyearId: string;
  schoolId: string;
  id: string;
  name: string;
  pluralName?: string;
  type: string;
  customFieldId: string;
  options: CustomFieldOption[];
}) {
  const requestURL = `/schoolyears/${props.schoolyearId}/schools/${props.schoolId}/eleves-custom-fields/${props.id}`;
  return request(requestURL, {
    method: 'PATCH',
    body: {
      id: props.customFieldId,
      name: props.name,
      pluralName: props.pluralName,
      type: props.type,
      options: props.options,
    },
  });
}

export default function useUpdateElevesCustomFields() {
  const { schoolyear, school } = useSchoolSchoolyear();
  const queryClient = useQueryClient();

  const { mutateAsync } = useMutation({
    mutationFn: (p: CustomFieldDefinition) =>
      updateEleveCustomFields({
        id: p.id,
        schoolyearId: schoolyear.id,
        schoolId: school.id,
        name: p.name,
        pluralName: p.pluralName,
        type: p.type,
        customFieldId: p.id,
        options: p.options,
      }),

    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [ELEVES_CUSTOM_FIELDS_KEY],
      });
      queryClient.invalidateQueries({
        queryKey: [ELEVES_VIEWS_KEY],
      });
      queryClient.invalidateQueries({
        queryKey: [ELEVES_ACCOUNT_KEY],
      });
    },
  });
  return mutateAsync;
}
